
(function(){
document.querySelectorAll('.zk3').forEach(function(R){
var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
function $(s,c){return (c||R).querySelector(s)} function $$(s,c){return [].slice.call((c||R).querySelectorAll(s))}
/* step nav: active + progress */
var nav=$('[data-zk3-nav]'),links=$$('a',nav),secs=$$('[data-s]'),prog=$('[data-zk3-prog]');
function onScroll(){
var mid=innerHeight*0.35,cur=null;
secs.forEach(function(s){var r=s.getBoundingClientRect();if(r.top<=mid&&r.bottom>mid)cur=s.dataset.s});
links.forEach(function(a){a.classList.toggle('is-on',a.dataset.t===cur);if(a.dataset.t===cur)a.setAttribute('aria-current','step');else a.removeAttribute('aria-current')});
var first=secs[0].getBoundingClientRect().top+scrollY,last=secs[secs.length-1].getBoundingClientRect().bottom+scrollY-innerHeight;
var p=Math.max(0,Math.min(1,(scrollY-first+innerHeight*0.35)/(last-first)));prog.style.transform='scaleX('+p+')';
var on=nav.querySelector('.is-on');if(on&&nav.scrollWidth>nav.clientWidth){on.scrollIntoView({block:'nearest',inline:'center'})}
}
addEventListener('scroll',onScroll,{passive:true});onScroll();
/* 1. water lab */
var lab=$('[data-zk3-water]');
if(lab){
var rg=$('[data-zk3-range]',lab),clock=$('[data-zk3-clock]',lab),play=$('[data-zk3-play]',lab),note=$('[data-zk3-note]'),t=null,last='';
var pr=$('.zk3-plume--real',lab),pf=$('.zk3-plume--fake',lab),ft=$('.zk3-fthread',lab);
var mr=$('[data-zk3-m=real]',lab),mf=$('[data-zk3-m=fake]',lab),tr=$('[data-zk3-p=real]',lab),tf=$('[data-zk3-p=fake]',lab);
function msg(s){if(s!==last){last=s;note.querySelector('span').textContent=s;note.classList.remove('is-pop');void note.offsetWidth;note.classList.add('is-pop')}}
function set(v){
var r=v/15,f=Math.min(1,v/1);
pr.style.opacity=(r*.9).toFixed(3);pr.style.transform='scale('+(.2+.8*r).toFixed(3)+')';
pf.style.opacity=(f*.92).toFixed(3);pf.style.transform='scale('+(.3+.8*f).toFixed(3)+')';
var c=Math.min(1,v/1.5);ft.style.fill='rgb('+Math.round(198+42*c)+','+Math.round(40+176*c)+','+Math.round(40+166*c)+')';
var rp=Math.round(r*100),fp=Math.round(f*100);mr.style.width=rp+'%';mf.style.width=fp+'%';tr.textContent=rp+'%';tf.textContent=fp+'%';
var m=Math.floor(v),s=Math.round((v-m)*60);clock.textContent=(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
rg.style.setProperty('--p',(r*100)+'%');rg.setAttribute('aria-valuetext',m+' minutes '+s+' seconds');
if(v===0)msg('Press play to start the test.');
else if(v<1)msg('Seconds in: the fake is already bleeding red.');
else if(v<5)msg('The fake has given up its colour. The real thread is only just starting.');
else if(v<12)msg('Real saffron keeps releasing a golden colour, slowly and steadily.');
else msg('15 minutes: golden water and a red thread. That is real saffron.');
}
function stop(){if(t){clearInterval(t);t=null}play.classList.remove('is-on')}
function start(){if(+rg.value>=15)rg.value=0;play.classList.add('is-on');t=setInterval(function(){var v=+rg.value+.25;if(v>=15){v=15;stop()}rg.value=v;set(v)},reduce?15:120)}
play.addEventListener('click',function(){t?stop():start()});
rg.addEventListener('input',function(){stop();set(+rg.value)});
set(0);
if('IntersectionObserver' in window&&!reduce){var io=new IntersectionObserver(function(e){if(e[0].isIntersecting){if(+rg.value===0&&!t)start();io.disconnect()}},{threshold:.35});io.observe(lab)}
}
/* 2. look toggle */
var look=$('[data-zk3-look]');
if(look){$$('.zk3-toggle button',look).forEach(function(b){b.addEventListener('click',function(){look.dataset.mode=b.dataset.mode;$$('.zk3-toggle button',look).forEach(function(x){x.setAttribute('aria-selected',x===b?'true':'false')})})})}
/* 3. senses tabs */
var sense=$('[data-zk3-sense]');
if(sense){
var tabs=$$('[role=tab]',sense),panels=$$('[role=tabpanel]',sense);
function pick(i,focus){tabs.forEach(function(t,k){t.setAttribute('aria-selected',k===i?'true':'false');t.tabIndex=k===i?0:-1});panels.forEach(function(p,k){p.hidden=k!==i});if(focus)tabs[i].focus()}
tabs.forEach(function(t,i){t.addEventListener('click',function(){pick(i)});t.addEventListener('keydown',function(e){var n=null;if(e.key==='ArrowRight'||e.key==='ArrowDown')n=(i+1)%tabs.length;if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=(i-1+tabs.length)%tabs.length;if(n!==null){e.preventDefault();pick(n,true)}})});
}
/* 4. myth or fact */
var mf=$('[data-zk3-mf]'),score=0,done=0,sc=$('[data-zk3-score]');
if(mf){$$('.zk3-mf__card',mf).forEach(function(c){$$('button',c).forEach(function(b){b.addEventListener('click',function(){
if(c.classList.contains('is-done'))return;c.classList.add('is-done');
var ok=b.dataset.g===c.dataset.ans;b.classList.add(ok?'is-right':'is-wrong');
if(!ok)c.querySelector('[data-g='+c.dataset.ans+']').classList.add('is-right');
c.classList.add(ok?'is-ok':'is-no');var a=c.querySelector('.zk3-mf__ans');a.hidden=false;
a.querySelector('strong').textContent=(ok?'Correct! ':'Not quite. ')+'It’s a '+c.dataset.ans+'.';
if(ok)score++;done++;sc.textContent=score+' / 4';
})})})}
/* 5. quiz */
var qz=$('[data-zk3-quiz]');
if(qz){
var qs=$$('.zk3-q',qz),res=$('[data-zk3-res]',qz),bar=$('[data-zk3-bar]',qz),cnt=$('[data-zk3-count]',qz),back=$('[data-zk3-back]',qz),i=0,ans=[];
function show(n,focus){
qs.forEach(function(q,k){q.hidden=k!==n;if(k===n){q.classList.remove('is-in');void q.offsetWidth;q.classList.add('is-in')}});
res.hidden=n<qs.length;back.hidden=n===0||n>=qs.length;
bar.style.transform='scaleX('+(Math.min(n,qs.length)/qs.length)+')';
cnt.textContent=n<qs.length?'Question '+(n+1)+' of '+qs.length:'Your result';
if(focus){var h=(n<qs.length?qs[n]:res).querySelector('h3');h&&h.focus({preventScroll:true})}
}
function result(){
var tot=0,s=0,list=$('[data-zk3-list]',qz);list.innerHTML='';
qs.forEach(function(q,k){var w=+q.dataset.w,a=ans[k];if(a!=='u'){tot+=w;if(a===1)s+=w}
var li=document.createElement('li');li.className=a===1?'ok':a===0?'no':'un';li.innerHTML='<span>'+(a===1?'✓':a===0?'✕':'?')+'</span>'+q.dataset.label;list.appendChild(li)});
var pct=tot?Math.round(s/tot*100):0,known=tot>0;
$('[data-zk3-needle]',qz).style.transform='rotate('+(-90+pct*1.8)+'deg)';
var pe=$('[data-zk3-pct]',qz);pe.textContent=known?pct+'%':'?';
var T,D;
if(!known){T='Try the tests first';D='You answered “Not sure” to everything. Do the water test above, then come back.'}
else if(pct>=80){T='Looks like genuine saffron';D='Your saffron passes the main home checks. For full certainty about grade, ask the seller for a lab report.'}
else if(pct>=45){T='Be cautious';D='Some signs are good and some are not. Repeat the water test with fresh threads, and buy from a seller who labels origin clearly.'}
else{T='Likely adulterated or fake';D='Several warning signs. Avoid cooking with it and ask the seller for an explanation or a lab report.'}
$('[data-zk3-title]',qz).textContent=T;$('[data-zk3-text]',qz).textContent=D;
res.className='zk3-res '+(!known?'is-mid':pct>=80?'is-good':pct>=45?'is-mid':'is-bad');
}
qs.forEach(function(q,k){$$('.zk3-ans',q).forEach(function(b){b.addEventListener('click',function(){
ans[k]=b.dataset.a==='u'?'u':+b.dataset.a;b.classList.add('is-picked');
setTimeout(function(){b.classList.remove('is-picked');i=k+1;if(i>=qs.length)result();show(i,true)},reduce?0:240);
})})});
back.addEventListener('click',function(){if(i>0){i--;show(i,true)}});
$('[data-zk3-restart]',qz).addEventListener('click',function(){ans=[];i=0;show(0,true)});
show(0);
}
/* reveal */
if('IntersectionObserver' in window&&!reduce){
var els=$$('.zk3-head,.zk3-split__copy,.zk3-lab,.zk3-look,.zk3-sense,.zk3-mf__card,.zk3-prom > div,.zk3-shop > a,.zk3-quizwrap__copy,.zk3-quiz');
var ro=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');ro.unobserve(e.target)}})},{threshold:.1,rootMargin:'0px 0px -40px 0px'});
els.forEach(function(el,k){if(el.getBoundingClientRect().top>innerHeight){el.classList.add('zk3-rv');el.style.transitionDelay=(k%4*70)+'ms';ro.observe(el)}});
}
});
})();
